import React, { useState, useImperativeHandle, forwardRef } from 'react';
import { Modal, Button } from 'reactstrap';
import './NotificationModal.css';

export interface NotificationModalHandle {
  open: (payload: { title: string; body: string }) => void;
  close: () => void;
}

export const notificationRef = React.createRef<NotificationModalHandle>();

const NotificationModal = forwardRef<NotificationModalHandle>(({ }, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState({ title: '', body: '' });

  useImperativeHandle(ref, () => ({
    open: (payload) => {
      setData({
        title: payload.title || 'Notification',
        body: payload.body || ''
      });
      setIsOpen(true);
    },
    close: () => {
      setIsOpen(false);
    }
  }));

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal
        isOpen={isOpen}
        toggle={handleClose}
        centered
        className="notification-modal"
      >
        <div className="modal-container">
          <div className="modal-icon-wrap">
            <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <h5 className="modal-title-text">{data.title}</h5>
          <p className="modal-body-text">{data.body}</p>
          <button className="modal-close-btn" onClick={handleClose}>
            Close
          </button>
        </div>
      </Modal>
  );
});

NotificationModal.displayName = 'NotificationModal';

export default NotificationModal;
